import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';
import { getStatusUsingWindow } from '.';

const getMsg = (phase, from, to) => {
  const getStatus = status => getStatusUsingWindow(phase, status);
  return `Status was changed from ${getStatus(from)} status to ${getStatus(to)} status.`;
};

export const override_status = ({
  event: { kind, data: { from_status, to_status }, phase },
}) => <div className={kind}>{getMsg(phase, from_status, to_status)}</div>;

override_status.defaultProps = { phase: {} };

override_status.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      from_status: PropTypes.string.isRequired,
      to_status: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/override_status.jsx